import { render, staticRenderFns } from "./codeadd.vue?vue&type=template&id=1d19ff6b&scoped=true"
import script from "./codeadd.vue?vue&type=script&lang=js"
export * from "./codeadd.vue?vue&type=script&lang=js"
import style0 from "./codeadd.vue?vue&type=style&index=0&id=1d19ff6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d19ff6b",
  null
  
)

export default component.exports